import NoResults from 'components/NoData/NoResults/NoResults'

export default NoResults
